// extracted by mini-css-extract-plugin
var _1 = "wu2onWrZ";
var _2 = "BjLWJtgj";
var _3 = "P8_c14cO";
var _4 = "t_bAlERs";
var _5 = "VvR_cLmk";
var _6 = "Rho6sQTT";
var _7 = "wPvB4n73";
export { _1 as "addBtn", _2 as "buttons", _3 as "clearBtn", _4 as "loadBtn", _5 as "pasteBtn", _6 as "saveBtn", _7 as "startBtn" }
